import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-qb-vendor-list',
  templateUrl: './qb-vendor-list.component.html',
  styleUrls: ['./qb-vendor-list.component.css'],
})
export class QbVendorListComponent {
  url: string = 'quickbooks';
  data: Array<any> = [];
  isLoading: boolean = false;
  apiUrl = environment.apiUrl;
  step = 1;
  /* resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Receipts/Transactions',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-city',
      bgClass: 'bg-white',
      desc: 'Refunds',
    },
  ]; */

  constructor(
    private dataService: DataService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.dataService.getData(`${this.url}/vendors`).subscribe((response) => {
      console.log('vendors', response);
      this.data = response.data.QueryResponse.Vendor;
      this.isLoading = false;
    });
  }

  deleteData(id: string, syncToken: string): void {
    if (!confirm('You want to delete the record?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/deactivateVendor/${id}/${syncToken}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  changeStep(step: number) {
    this.step = step;
  }
}
